import { render, staticRenderFns } from "./commonsms.vue?vue&type=template&id=e2e59fe6&scoped=true"
import script from "./commonsms.vue?vue&type=script&lang=js"
export * from "./commonsms.vue?vue&type=script&lang=js"
import style0 from "./commonsms.vue?vue&type=style&index=0&id=e2e59fe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e59fe6",
  null
  
)

export default component.exports